import React from "react";
import "./Footer.css";
import logo from "../../assets/Navbar/anupreetha-logo-violet.svg";

const Footer = () => {
  return (
    <section className="section4">
      <div className="footer">
        <div className="footerlogo">
          <a href="#homepage">
            <img src={logo} alt="logo" />
          </a>
        </div>
        <div className="footercredit">
          designed & developed by me
          <span
            className="footerpic"
            title="no shaky shaky, but here you go: 🩷 "
          >
            :&#41;
          </span>
        </div>
      </div>
    </section>
  );
};

export default Footer;
